/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ExportIpynbMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type ExportIpynbMutation = {
  readonly __typename: "Mutation";
  readonly exportIpynb: {
    readonly __typename: "IpynbExport";
    readonly filename: string;
    readonly content: string;
  };
};

export type ExportProjectMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type ExportProjectMutation = {
  readonly __typename: "Mutation";
  readonly exportHexVersion: {
    readonly __typename: "HexExport";
    readonly filename: string;
    readonly content: string;
  };
};

export const ExportIpynbDocument = /*#__PURE__*/ gql`
  mutation ExportIpynb($hexVersionId: HexVersionId!) {
    exportIpynb(hexVersionId: $hexVersionId) {
      filename
      content
    }
  }
`;
export type ExportIpynbMutationFn = Apollo.MutationFunction<
  ExportIpynbMutation,
  ExportIpynbMutationVariables
>;

/**
 * __useExportIpynbMutation__
 *
 * To run a mutation, you first call `useExportIpynbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportIpynbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportIpynbMutation, { data, loading, error }] = useExportIpynbMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useExportIpynbMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportIpynbMutation,
    ExportIpynbMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportIpynbMutation, ExportIpynbMutationVariables>(
    ExportIpynbDocument,
    options,
  );
}
export type ExportIpynbMutationHookResult = ReturnType<
  typeof useExportIpynbMutation
>;
export type ExportIpynbMutationResult =
  Apollo.MutationResult<ExportIpynbMutation>;
export type ExportIpynbMutationOptions = Apollo.BaseMutationOptions<
  ExportIpynbMutation,
  ExportIpynbMutationVariables
>;
export const ExportProjectDocument = /*#__PURE__*/ gql`
  mutation ExportProject($hexId: HexId!) {
    exportHexVersion(hexId: $hexId) {
      filename
      content
    }
  }
`;
export type ExportProjectMutationFn = Apollo.MutationFunction<
  ExportProjectMutation,
  ExportProjectMutationVariables
>;

/**
 * __useExportProjectMutation__
 *
 * To run a mutation, you first call `useExportProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportProjectMutation, { data, loading, error }] = useExportProjectMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useExportProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportProjectMutation,
    ExportProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportProjectMutation,
    ExportProjectMutationVariables
  >(ExportProjectDocument, options);
}
export type ExportProjectMutationHookResult = ReturnType<
  typeof useExportProjectMutation
>;
export type ExportProjectMutationResult =
  Apollo.MutationResult<ExportProjectMutation>;
export type ExportProjectMutationOptions = Apollo.BaseMutationOptions<
  ExportProjectMutation,
  ExportProjectMutationVariables
>;
